// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__25SSS","messages":"Chat_messages__12bbS","dateDivider":"Chat_dateDivider__1w0Uk"};